import { useContext, useState } from "react"
import EditVisitContext from "./EditVisitContext"
import { EnrichedItem } from "./item"
import { Button, InputNumber, Popover, Space, Table, Typography } from "antd"
import { red } from "@ant-design/colors"
import ItemSelector from '../ItemCatalog/ItemSelector'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTrash } from "@fortawesome/pro-solid-svg-icons"

const { Link } = Typography

type Props = {
  workareaId: number
  items: EnrichedItem[]
}

const WorkareaItems = ({ workareaId, items }: Props) => {
  const data = useContext(EditVisitContext)
  const [itemSelectorOpen, setItemSelectorOpen] = useState(false)

  return <Space direction="vertical" style={{ width: '100%' }}>
    <Space direction="horizontal">
      <Popover
        open={itemSelectorOpen}
        onOpenChange={setItemSelectorOpen}
        trigger="click"
        placement="left"
        content={
          <ItemSelector
            onAdd={(item) => {
              data.dispatch({ type: 'ADD_ITEM', workareaId, item })
            }}
          />
        }
      >
        <Button>
          Add Items
        </Button>
      </Popover>
    </Space>
    <Table
      dataSource={items}
      rowKey={(item) => item.key}
      columns={[
        {
          title: 'Name',
          dataIndex: 'name'
        },
        {
          title: 'Estimated Quantity',
          dataIndex: 'estimatedQty'
        },
        {
          title: 'Units',
          dataIndex: 'units'
        },
        {
          title: 'Visit Quantity',
          dataIndex: 'visitActualQty',
          render: (_, item) => {
            return <InputNumber min={0} value={item.visitActualQty}
              status={item.quantityChanged ? 'warning' : undefined}
              onChange={(x) => data.dispatch({ type: 'CHANGE_ITEM_QUANTITY', workareaId, quantity: { ...item, quantity: x ?? 0 } })} />
          }
        },
        {
          title: 'Job Quantity',
          dataIndex: 'jobActualQty'
        },
        {
          render: (_, item) =>
            <Space size="middle" style={{ fontSize: '1.25em' }}>
              {item.canBeRemoved &&
                <Link onClick={() => data.dispatch({ type: 'REMOVE_ITEM', workareaId, catalogItemGuid: item.catalogItemGuid })}>
                  <FontAwesomeIcon icon={faTrash} style={{color: red.primary}} />
                </Link>}
            </Space>
        }
      ]}
    />
  </Space>
}
export default WorkareaItems
